import { KillSkillType } from "../types/KillSkillType";

export const KillSkillTypeList: KillSkillType[] = [
  {
    id: 0,
    title: "Practise on bottles in your backyard",
    percentage: 4,
    cost: 0,
    image: "/assets/imgs/killskill/1.png",
  },
  {
    id: 1,
    title: "Take a day at the shooting range",
    percentage: 8,
    cost: 5000,
    image: "/assets/imgs/killskill/2.png",
  },
  {
    id: 2,
    title: "Hire a personal trainer",
    percentage: 18,
    cost: 30000,
    image: "/assets/imgs/killskill/3.png",
  },
];
